
import React, { useCallback } from 'react';
import { QuestionList } from "../QuestionList";
import { Question } from "@/types/test";

interface QuestionListSectionProps {
  questions: Question[];
  onAddQuestion: () => string; // Updated to return the new question ID
  onUpdateQuestion: (id: string, updates: Partial<Question>) => void;
  onDeleteQuestion: (id: string) => void;
  onRegenerateQuestion?: (id: string, feedback: string) => Promise<void>;
  jobContext?: {
    title?: string;
    description?: string;
    keySkills?: string[];
    yearsOfExperience?: string;
  };
}

export const QuestionListSection = React.memo(({
  questions,
  onAddQuestion,
  onUpdateQuestion,
  onDeleteQuestion,
  onRegenerateQuestion,
  jobContext,
}: QuestionListSectionProps) => {
  console.log('Rendering QuestionListSection');
  
  return (
    <QuestionList
      questions={questions}
      onAddQuestion={onAddQuestion}
      onUpdateQuestion={onUpdateQuestion}
      onDeleteQuestion={onDeleteQuestion}
      onRegenerateQuestion={onRegenerateQuestion}
      jobContext={jobContext}
    />
  );
});

QuestionListSection.displayName = 'QuestionListSection';
